import { gql } from 'apollo-boost';

export const outdoorPlacementBlock = gql`
    fragment OutdoorPlacementBlock on GdOutdoorPlacementBlock {
        blockCaption
        blockId
        isDeleted
        lastChange
        pageId
        sizes {
            height
            width
        }
        address
        coordinates
        duration
        direction
        facilityType
        geoId
        height
        hidden
        photos {
            formats {
                height
                path
                width
            }
        }
        resolution {
            height
            width
        }
        width
    }
`;

export const indoorPlacementBlock = gql`
    fragment IndoorPlacementBlock on GdIndoorPlacementBlock {
        blockCaption
        blockId
        isDeleted
        lastChange
        pageId
        sizes {
            height
            width
        }
        geoId
        address
        coordinates
        facilityType
        zoneCategory
        aspectRatio
        hidden
        photos {
            formats {
                height
                path
                width
            }
        }
        resolution {
            height
            width
        }
    }
`;

export const placementsQuery = gql`
    query PlacementsQuery($input: GdPlacementFilterInput!) {
        reqId: getReqId
        placements(input: $input) {
            regionDictionary {
                id
                nameEn
                nameRu
                nameTr
                nameUa
            }
            facilityDictionary {
                key
                value
            }
            zoneDictionary {
                key
                value
            }
            placements {
                operatorName
                caption
                domain
                id
                isDeleted
                isTesting
                isYandexPage
                login
                type
            }
            placementBlocks {
                ...OutdoorPlacementBlock
                ...IndoorPlacementBlock
            }
        }
    }
    ${outdoorPlacementBlock}
    ${indoorPlacementBlock}
`;
